import { InfoPayload } from '~/common/types/types';

const infoPayload: InfoPayload = {
  title: 'technology.qa.info.title',
  items: [
    {
      icon: 'magister',
      title: 'technology.qa.info.group0.title',
      description: 'technology.qa.info.group0.description',
    },
    {
      icon: 'gear',
      title: 'technology.qa.info.group1.title',
      description: 'technology.qa.info.group1.description',
    },
    {
      icon: 'star',
      title: 'technology.qa.info.group2.title',
      description: 'technology.qa.info.group2.description',
    },
    {
      icon: 'laptop',
      title: 'technology.qa.info.group3.title',
      description: 'technology.qa.info.group3.description',
    },
    {
      icon: 'award',
      title: 'technology.qa.info.group4.title',
      description: 'technology.qa.info.group4.description',
    },
    {
      icon: 'diplomatic',
      title: 'technology.qa.info.group5.title',
      description: 'technology.qa.info.group5.description',
    },
    {
      icon: 'ai',
      title: 'technology.qa.info.group6.title',
      description: 'technology.qa.info.group6.description',
    },
  ],
  registrationBtn: 'registration.signUp',
};

export { infoPayload };
